import React from 'react';
import { ModalConfirmDelete } from './ModalConfirmDelete';
import { StyledModalCancel } from './ModalConfirmDelete';
import { useTranslation } from 'react-i18next';
import { paySumupInit } from 'helpers/api-requests/admin';
import { openNewPage } from 'helpers/redirect';
import { SumupImage } from 'assets/images/companies';
import { Col, Row } from 'reactstrap';
import { confirmOrder } from 'helpers/api-requests/manager';

export const ModalPayment = ({
  isOpenModal,
  billId,
  orderId,
  handleCloseModal,
}) => {
  const { t } = useTranslation();

  const handlePaySumup = orderId => {
    confirmOrder(orderId).then(
      response =>
        response.success &&
        paySumupInit(billId).then(response => {
          if (response.success) {
            openNewPage(response.data.payment_url);
            handleCloseModal();
          }
        }),
    );
  };

  return (
    <ModalConfirmDelete
      handleCloseModal={handleCloseModal}
      textHeader="payments.payment"
      isOpenModal={isOpenModal}
      showBtn={false}
      showCancelBtn={false}
    >
      <Row className="d-flex justify-content-between g-3 flex-wrap">
        <Col xs={12} sm={12}>
          <StyledModalCancel
            className="w-100"
            onClick={() => handlePaySumup(orderId)}
          >
            {t('payments.continue', { paymentType: '' })}
            <SumupImage />
          </StyledModalCancel>
        </Col>
      </Row>
    </ModalConfirmDelete>
  );
};
